import {
	type EntryPoint,
	type Environment,
	loadEntryPoint,
	type PreloadedEntryPoint,
} from 'react-relay';

import type {
	EntryPointParams,
	EntryPointRoute,
	Plugin,
	PluginOptions,
	StudioRouteContext,
} from './types';
import { prevPrefetchingRoute } from './utils';

const entryPointReferences: {
	[routeName: string]: PreloadedEntryPoint<any> | null;
} = {};

export const getRouteEntryPointReference = (
	route: EntryPointRoute,
): PreloadedEntryPoint<any> | null => entryPointReferences[route.name] || null;

const handleRouteLoad = (
	{ environment, entryPointParams }: PluginOptions,
	context: StudioRouteContext,
): void => {
	const entryPoint = context.route.entryPoint?.();

	const entryPointParamsWithContext = {
		context,
		...entryPointParams,
	};

	if (entryPoint) {
		if (prevPrefetchingRoute.isSameRouteMatch(context)) {
			return;
		}

		entryPointReferences[context.route.name] = loadEntryPoint(
			{ getEnvironment: () => environment },
			entryPoint as EntryPoint<any, typeof entryPointParamsWithContext>,
			entryPointParamsWithContext,
		);
	}

	// Store the current route context as the previous prefetching route
	prevPrefetchingRoute.setPrevRouteContext(context);
};

export const createEntryPointPlugin = (pluginOptions: {
	entryPointParams: EntryPointParams;
	environment: Environment;
}): Plugin => ({
	id: 'entry-points-plugin',
	routeLoad: ({ context }) => handleRouteLoad(pluginOptions, context),
	routePrefetch: ({ nextContext }) => handleRouteLoad(pluginOptions, nextContext),
});
